import React from 'react'
import Header from '../../components/Navbar/Header'
import MainBanner from '../../components/Banner/MainBanner'
import SignUpForm from '../../components/SignUpForm/SignUpForm'
import Footer from '../../components/Footer/Footer'
import SelectRole from '../SelectRole'
import SecondHeader from '../../components/SecondHeader/SecondHeader'

const SignUp = () => {
    return (
        <>
            {/* <Header /> */}
            <SecondHeader/>
            <MainBanner />
            <SelectRole/>
            <SignUpForm />
            <Footer />
        </>
    )
}

export default SignUp